module.exports = __webpack_public_path__ + "images/emoji/tanabata_tree.de40e8c72404da0e6d75.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tanabata_tree.png
// module id = wSdm
// module chunks = 13